<template>
  <div>
    <common-dialog
      ref="dialog"
      :width="isMB?'86%':'600px'"
      :title="text"
      :data="data"
      :save-func="()=>{}"
      @closed="onClosed"
    >
      <template slot="form">
        <el-form-item label="实际结束时间" class="is-required" label-width="110px">
          <div style="display: flex;">
            <el-date-picker
              v-model="data.ActualEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :clearable="false"
            ></el-date-picker>
            <div style="width: 15px;"></div>
            <el-select v-model="data.ActualEndTimePart" style="width: 130px;">
              <el-option label="上午" value="上午"></el-option>
              <el-option label="下午" value="下午"></el-option>
              <el-option label="晚上" value="晚上"></el-option>
            </el-select>
          </div>
        </el-form-item>
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        <el-button type="primary" :loading="isLoading" @click="save">提 交</el-button>
        <el-button @click="close">取 消</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      text: "销假",
      data: {
        InstanceId: "",
        StartTime: "",
        StartTimePart: "",
        EndTime: "",
        ActualEndTime: "",
        EndTimePart: "",
        ActualEndTimePart: "",
        Duration: null,
      },

      isMB: this.$store.state.isMB,
      api: require("@/api/wf/wfleave").default,
    };
  },
  computed: {},
  methods: {
    save() {
      if (!this.data.ActualEndTime || !this.data.ActualEndTimePart) {
        this.$message.warning("请选择时间");
        return;
      }

      var actual_1 = this.$commonJs.toDateString(this.data.ActualEndTime);
      // var actual_2 = this.data.ActualEndTimePart == "上午" ? 0 : 1;
      var actual_2 = 0; //上午
      if (this.data.ActualEndTimePart == "下午") actual_2 = 1;
      if (this.data.ActualEndTimePart == "晚上") actual_2 = 2;

      var start_1 = this.$commonJs.toDateString(this.data.StartTime);
      // var start_2 = this.data.StartTimePart == "上午" ? 0 : 1;
      var start_2 = 0; //上午
      if (this.data.StartTimePart == "下午") start_2 = 1;
      if (this.data.StartTimePart == "晚上") start_2 = 2;

      var end_1 = this.$commonJs.toDateString(this.data.EndTime);
      // var end_2 = this.data.EndTimePart == "上午" ? 0 : 1;
      var end_2 = 0; //上午
      if (this.data.EndTimePart == "下午") end_2 = 1;
      if (this.data.EndTimePart == "晚上") end_2 = 2;

      if (actual_1 < start_1) {
        this.$message.warning("实际结束时间不能小于开始时间");
        return;
      }

      if (actual_1 > end_1) {
        this.$message.warning("实际结束时间不能大于结束时间");
        return;
      }

      if (actual_1 == start_1) {
        if (actual_2 < start_2) {
          this.$message.warning("实际结束时间不能小于开始时间");
          return;
        }
      }

      if (actual_1 == end_1) {
        if (actual_2 > end_2) {
          this.$message.warning("实际结束时间不能大于结束时间");
          return;
        }
      }

      if (!(actual_1 == end_1 && actual_2 == end_2)) {
        var start_time = new Date(start_1).getTime() / 1000;
        var end_time = new Date(actual_1).getTime() / 1000;
        var diff_day = parseInt((end_time - start_time) / 60 / 60 / 24); //相差天数

        // console.log("diff_day", diff_day);
        var value = 0;

        if (start_2 == 0 && actual_2 == 0) {
          if (diff_day == 0) value = 0.5;
          else value = diff_day + 0.5;
        }
        if (start_2 == 1 && (actual_2 == 1 || actual_2 == 2)) {
          if (diff_day == 0) value = 0.5;
          else value = diff_day + 0.5;
        }
        if (start_2 == 0 && actual_2 == 1) {
          if (diff_day == 0) value = 1;
          else value = diff_day + 1;
        }
        if (start_2 == 0 && actual_2 == 2) {
          if (diff_day == 0) value = 1;
          else value = diff_day + 1;
        }
        if (start_2 == 2 && actual_2 == 2) {
          if (diff_day == 0) value = 0.5;
          else value = diff_day + 0.5;
        }
        if (start_2 == 2 && actual_2 == 1) {
          if (diff_day == 0) {
          } else value = diff_day + 0.5;
        }
        if ((start_2 == 1 || start_2 == 2) && actual_2 == 0) {
          if (diff_day == 0) {
          } else value = diff_day;
        }
        this.data.Duration = value;
        console.log("Duration", this.data.Duration);
      }

      var data = this.$commonJs.obj.removeNullKey(this.data);
      console.log("save", data);
      this.$refs.dialog.isLoading = true;
      this.api.end(data).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message({
            customClass: "my-msg",
            type: "success",
            message: "销假成功",
          });
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message({
            customClass: "my-msg",
            type: "error",
            message: res.Msg,
          });
        }
      });
    },
    onClosed() {
      this.data.ActualEndTime = "";
      this.data.ActualEndTimePart = "";
    },
  },
};
</script>